exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".splash {\n    position: absolute;\n    z-index: 2000;\n    background: white;\n    color: gray;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0\n}\n\n.splash-title {\n    text-align: center;\n    max-width: 500px;\n    margin: 15% auto;\n    padding: 20px\n}\n\n.splash-title h1{\n    font-size: 26px\n}\n\n.color-line {\n    border-radius:4px 4px 0 0\n}", ""]);

// exports
